import { render } from "./doorToDoor.vue?vue&type=template&id=184a2860&scoped=true"
import script from "./doorToDoor.vue?vue&type=script&lang=js"
export * from "./doorToDoor.vue?vue&type=script&lang=js"

import "./doorToDoor.vue?vue&type=style&index=0&id=184a2860&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184a2860"]])

export default __exports__